import type {GiftCardProviders} from ".";

export type GiftCardTypes = "GiftCard" | "GoDreamGiftCard" | "KlippeCard" | "ThirdPartyGiftCard";
export interface Voucher {
  type: GiftCardTypes;
  code: string;
}

/**
 * Base GiftCard Class
 */
export class GiftCard implements Voucher {
  code: string;
  giftCardProvider: GiftCardProviders;
  readonly type: GiftCardTypes = "GiftCard";

  constructor(giftCardCode: string, giftCardProvider: GiftCardProviders) {
    this.code = giftCardCode;
    this.giftCardProvider = giftCardProvider;
  }
}

/**
 * All ThirdParty Giftcards needs a type
 */
export class ThirdPartyGiftCard extends GiftCard {
  readonly type: GiftCardTypes = "ThirdPartyGiftCard";
  providerId: number;

  constructor(code: string, provider: GiftCardProviders, providerId: number) {
    super(code, provider);
    this.providerId = providerId;
  }
}

/**
 * GoDream ThirdParty Cards furthermore needs an Activation code.
 */
export class GoDreamGiftCard extends ThirdPartyGiftCard {
  readonly type: GiftCardTypes = "GoDreamGiftCard";
  activationCode: string;

  constructor(code: string, providerId: number, activationCode: string) {
    super(code, "GoDream", providerId);
    this.activationCode = activationCode;
  }
}

export class KlippeCard implements Voucher {
  readonly type: GiftCardTypes = "KlippeCard";
  code: string;

  constructor(code: string) {
    this.code = code;
  }
}
